import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { Camera, User } from "../types";

interface UserEditModalProps {
    editingUser: User | null;
    cameras: Camera[];
    loadingUpdateUser: boolean;
    setEditingUser: (user: User) => void;
    updateUser: (user: User) => void;
    open: boolean;
    handleClose: () => void;
}

export default function UserEditModal({ editingUser, cameras, loadingUpdateUser, setEditingUser, updateUser, open, handleClose }: UserEditModalProps) {
    if (!editingUser) return null;

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        updateUser(editingUser);
        handleClose();
    }

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <form onSubmit={handleSubmit}>
                <DialogTitle>Editing User...</DialogTitle>

                <DialogContent dividers>
                    <TextField
                        label="Email"
                        value={editingUser.email}
                        onChange={(e) => setEditingUser({ ...editingUser, email: e.target.value })}
                        fullWidth
                        margin="normal"
                        disabled
                    />
                    <TextField
                        label="Password"
                        type="password"
                        value={editingUser.password || ''}
                        onChange={(e) => setEditingUser({ ...editingUser, password: e.target.value })}
                        fullWidth
                        margin="normal"
                    />
                    {editingUser.role === 'customer' && (
                        <FormControl fullWidth margin="normal">
                            <InputLabel>Camera</InputLabel>
                            <Select
                                multiple
                                label="Camera"
                                value={editingUser.camera_ids || []}
                                onChange={(e) =>
                                    setEditingUser({ ...editingUser, camera_ids: e.target.value as string[] })
                                }
                            >
                                <MenuItem value="">None</MenuItem>
                                {cameras.map((camera) => (
                                    <MenuItem key={camera.id} value={camera.id}>
                                        {camera.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                    <TextField
                        label="Notes"
                        value={editingUser.notes}
                        onChange={(e) => setEditingUser({ ...editingUser, notes: e.target.value as string })}
                        fullWidth
                        margin="normal"
                        multiline
                        rows={4} />
                </DialogContent>

                <DialogActions>
                    <Button
                        type="submit"
                        variant="contained"
                        disabled={loadingUpdateUser}
                    >
                        Update
                    </Button>
                    <Button onClick={handleClose}>Cancel</Button>
                </DialogActions>
            </form>
        </Dialog >
    )
}